module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[25]24.0674780.woff2";